(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["fyre-content"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-fyre-fit-heading]';
  const headingSelector = ':scope > h1, :scope > h2, :scope > h3, :scope > h4, :scope > h5, :scope > h6';

  const getMaximumSize = (element) => {
    const desktopSize = Number(element.dataset.fontSizeDesktop) || 0;
    const mobileSize = Number(element.dataset.fontSizeMobile) || 0;
    return window.matchMedia('(max-width: 767px)').matches
      ? (mobileSize || desktopSize)
      : desktopSize;
  };

  const fitHeading = (element) => {
    const maximumSize = getMaximumSize(element);
    const heading = element.querySelector(headingSelector);
    if (!heading || maximumSize <= 0 || element.clientWidth <= 0) return;

    // The DPP build name intentionally crosses from the copy panel into the
    // image at tablet widths. Preserve its configured size instead of fitting
    // it to the copy column, and release only its ancestor group clips.
    const isBuildTitleOverflow =
      element.hasAttribute('data-fyre-tablet-heading-overflow') &&
      window.matchMedia('(min-width: 768px) and (max-width: 1100px)').matches;

    let ancestor = element.parentElement;
    while (ancestor && !ancestor.classList.contains('fyre-section-content-section')) {
      if (ancestor.classList.contains('fyre-group')) {
        ancestor.classList.toggle('fyre-group--build-title-overflow', isBuildTitleOverflow);
      }
      ancestor = ancestor.parentElement;
    }

    if (isBuildTitleOverflow) {
      heading.style.setProperty('font-size', `${maximumSize}px`, 'important');
      return;
    }

    const previousWhiteSpace = heading.style.whiteSpace;
    heading.style.whiteSpace = 'nowrap';
    heading.style.setProperty('font-size', `${maximumSize}px`, 'important');

    if (heading.scrollWidth > heading.clientWidth + 1) {
      let minimumSize = 1;
      let maximumFitSize = maximumSize;
      let fittedSize = 1;

      while (minimumSize <= maximumFitSize) {
        const candidateSize = Math.floor((minimumSize + maximumFitSize) / 2);
        heading.style.setProperty('font-size', `${candidateSize}px`, 'important');

        if (heading.scrollWidth <= heading.clientWidth + 1) {
          fittedSize = candidateSize;
          minimumSize = candidateSize + 1;
        } else {
          maximumFitSize = candidateSize - 1;
        }
      }

      heading.style.setProperty('font-size', `${fittedSize}px`, 'important');
    }

    heading.style.whiteSpace = previousWhiteSpace;
  };

  const initialize = (scope = document) => {
    const elements = scope.matches?.(selector)
      ? [scope]
      : Array.from(scope.querySelectorAll(selector));

    elements.forEach((element) => {
      if (!element.dataset.fyreFitObserved && 'ResizeObserver' in window) {
        const observer = new ResizeObserver(() => fitHeading(element));
        observer.observe(element);
        element.dataset.fyreFitObserved = 'true';
      }
      fitHeading(element);
    });
  };

  const refresh = (event) => {
    requestAnimationFrame(() => initialize(event?.target || document));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh, { once: true });
  } else {
    refresh();
  }

  document.addEventListener('shopify:section:load', refresh);
  document.fonts?.ready.then(() => initialize());
})();
  } catch(e) { console.error(e); }
})();

})();
